var React = require('react');

function Ewar (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Support Fighter"),React.createElement("g",{"id":"layer1","key":2},[React.createElement("path",{"id":"path1458","className":"cls-1","d":"M54,34H74L84,44V84L74,94H54L44,84V44Z","key":0}),React.createElement("path",{"id":"path1460","className":"cls-1","d":"M84,44,94,34h20","key":1}),React.createElement("path",{"id":"path1462","className":"cls-1","d":"M44,44,34,34H14","key":2}),React.createElement("path",{"id":"path1464","className":"cls-1","d":"M44,84,34,94H14","key":3}),React.createElement("path",{"id":"path1466","className":"cls-1","d":"M84,84,94,94h20","key":4})])]);
}

Ewar.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Ewar;

Ewar.default = Ewar;
